import React from 'react';
import {Alert} from '@material-ui/lab';
import {Avatar, Box, Card, CardContent, CardHeader, List, ListItem, ListItemText} from "@material-ui/core";
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

const PortfolioCard = ({portfolios, cardClasses}) =>  (
    <Card component={Card} className={cardClasses.card}>
        <div>
            <CardHeader
                avatar={
                    <Avatar aria-label="type" className={cardClasses.contact}>
                        <MonetizationOnIcon/>
                    </Avatar>
                }
                title="Portfolios in Servicer"
                subheader={''}
            />
            <CardContent className={cardClasses.minHeight}>
                {portfolios.length ? (
                    <List>
                        {portfolios.map(item => (
                            <ListItem key={item.id}>
                                <ListItemText>
                                    <a
                                        href="/#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const id = `portfolio-${item.id}`;
                                            const yOffset = -10;
                                            const element = document.getElementById(id);
                                            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                            window.scrollTo({top: y, behavior: 'smooth'});
                                        }}
                                    >
                                        {item.name || item.id}
                                    </a>
                                </ListItemText>
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <Alert severity="warning">Currently, this servicer has no portfolios assigned to it.</Alert>
                )}
            </CardContent>
        </div>
    </Card>
);

export default PortfolioCard;
